import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import validator from "validator";
import SignatureCanvas from "react-signature-canvas";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Tooltip from "@mui/material/Tooltip";

const SignUpLayer = () => {
  const imagePath = `${process.env.PUBLIC_URL}/assets/images/auth/auth-img.png`;
  const imagePath2 = `https://aiwealth.blueastercapital.com/corporate/onboarding/assets/images/aiwealthlogo.png`;

  const BaseUrl = process.env.REACT_APP_API;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isDisable, setDisable] = useState(false);
  const [signatureURL, setSignatureURL] = useState("");
  const [strength, setStrength] = useState(0);
  const [email, setEmail] = useState("");
  const [isValidEmail, setValidEmail] = useState(true);
  const [isBlacklistedName, setBlacklistedNameExists] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [countries, setCountries] = useState([]);

  const [form, setForm] = useState({
    name_of_institution: "",
    legal_status: "",
    country_of_incorporation: "",
    registration_number: "",
    incorporation_date: "",
    registering_authority: "",
    business_activity: "",
    annual_turnover: "",
    type_of_profile: "",
    type_of_account: "",
    nature_of_account: "",
    anticipated_volume: "",
    source_of_funds: "",
    purpose_and_intended_nature_of_business: "",
    regulatory_body: "",
    senior_management_names: "",
    external_auditor_name: "",
    no_of_employees: "",
    address1: "",
    address2: "",
    city: "",
    pobox: "",
    country: "",
    telephone: "",
    fax: "",
    email: "",
    password: "",
    website: "",
    commercial_registration: null,
    vat_registration: null,
    company_registration: null,
    authorized_signatory_proof: null,
    memorandum_of_association: null,
    articles_of_association: null,
    partnership_agreement: null,
    board_resolution: null,
    list_of_authorized_signatories: null,
    latest_final_report_and_accounts: null,
    acting_on_my_behalf: "",
    acting_on_behalf_of: "",
    acting_on_behalf_name: "",
    information_true: "",
    notify_on_change: "",
    signatory_name: "",
    digital_signature: "",
    declaration_date: "",
  });
  const [isRegulatoryApplicable, setIsRegulatoryApplicable] = useState(false);
  const [isSeniorManagementApplicable, setIsSeniorManagementApplicable] =
    useState(false);
  const [isExternalAuditorApplicable, setIsExternalAuditorApplicable] =
    useState(false);

  const handleRegulatoryCheckboxChange = (event) => {
    setIsRegulatoryApplicable(event.target.checked);
  };

  const handleSeniorManagementCheckboxChange = (event) => {
    setIsSeniorManagementApplicable(event.target.checked);
  };

  const handleExternalAuditorCheckboxChange = (event) => {
    setIsExternalAuditorApplicable(event.target.checked);
  };

  const nextStep = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;
    if (type === "file") {
      setForm({
        ...form,
        [name]: files[0],
      });
    } else if (type === "checkbox") {
      setForm({
        ...form,
        [name]: checked ? 1 : 0,
      });
    } else {
      setForm({
        ...form,
        [name]: value,
      });
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const maxSize = 10 * 1024 * 1024;

    if (files.length === 0) {
      setForm({
        ...form,
        [name]: null,
      });
      return;
    }

    if (files[0].type !== "application/pdf") {
      toast.error("Only PDF files are allowed.");
      e.target.value = null;
      setForm({
        ...form,
        [name]: null,
      });
      return;
    }

    if (files[0].size > maxSize) {
      toast.error("File size exceeds 10 MB. Please select a smaller file.");
      e.target.value = null;
      setForm({
        ...form,
        [name]: null,
      });
    } else {
      setForm({
        ...form,
        [name]: files[0],
      });
    }
  };

  const handleEmailChange = (event) => {
    const newEmail = event.target.value;
    const regex = /\+[^\@]*@gmail\.com$/;
    const isValidEmail = !regex.test(newEmail);
    setEmail(newEmail);
    setValidEmail(validator.isEmail(newEmail) && isValidEmail);
  };

  const handleCombinedChange = async (e) => {
    handleChange(e);
    handleEmailChange(e);

    await new Promise((resolve) => setTimeout(resolve, 0));

    const email = e.target.value;
    try {
      const response = await axios.get(`${BaseUrl}/email-check?Email=${email}`);
      const { EmailExists } = response.data;
      setEmailExists(EmailExists);
    } catch (error) {
      console.error("Error checking email:", error);
    }
  };

  const handleBlacklistedNameChange = async (e) => {
    handleChange(e);

    await new Promise((resolve) => setTimeout(resolve, 0));

    const full_legal_name = e.target.value;
    try {
      const response = await axios.get(
        `${BaseUrl}/blaclisted-name-check?name=${full_legal_name}`
      );
      const { BlacklistedNameExists } = response.data;
      setBlacklistedNameExists(BlacklistedNameExists);
    } catch (error) {
      console.error("Error checking email:", error);
    }
  };

  const calculatePasswordStrength = (password) => {
    let score = 0;
    if (password.length >= 8) score++;
    if (/\d/.test(password)) score++;
    if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score++;
    if (/[!@#$%^&*()_+{}\[\]:;<>,.?~\\|\-=]/.test(password)) score++;
    setStrength(score);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const sigPad = useRef({});
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);

  const clear = () => {
    sigPad.current.clear();
    setTrimmedDataURL(null);
  };

  const trim = () => {
    const canvas = sigPad.current.getTrimmedCanvas();
    canvas.toBlob((blob) => {
      setTrimmedDataURL(URL.createObjectURL(blob)); // For local preview or use as needed

      // Update the form state with the blob
      setForm({
        ...form,
        digital_signature: blob,
      });
    }, "image/png");
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   try {
  //     const formData = new FormData();
  //     Object.keys(form).forEach((key) => {
  //       formData.append(key, form[key]);
  //     });

  //     formData.append("referral_code", "MARK-10017");

  //     const response = await axios.post(`${BaseUrl}/submitCompanyInfo`, formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     setLoading(false);
  //     if (response.data.status === "success") {
  //       const token = response.data.token;
  //       if (token) {
  //         sessionStorage.setItem("authToken", token);
  //       }
  //       toast.success("Registration completed successfully!");
  //       navigate("/dashboard");
  //     }
  //   } catch (err) {
  //     setLoading(false);
  //     console.error("Error submitting the form:", err);
  //     toast.error("Registration failed. Please try again.");
  //   }
  // };

  // Fetch countries
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Show processing toast (single instance)
    toast.dismiss();
    const processingToast = toast.loading("Processing...");

    // ALL REQUIRED FIELDS (Merged)
    const requiredFields = [
      { field: "name_of_institution", label: "Name of Institution" },
      { field: "legal_status", label: "Legal Status" },
      { field: "country_of_incorporation", label: "Country of Incorporation" },
      { field: "registration_number", label: "Registration Number" },
      { field: "incorporation_date", label: "Incorporation Date" },
      { field: "business_activity", label: "Business Activity" },
      { field: "annual_turnover", label: "Annual Turnover" },
      { field: "type_of_profile", label: "Residential Status" },
      { field: "nature_of_account", label: "Nature of Account" },
      { field: "anticipated_volume", label: "Tentative Investment" },
      { field: "source_of_funds", label: "Source of Funds" },
      {
        field: "purpose_and_intended_nature_of_business",
        label: "Purpose and Intended Nature of Business",
      },
      { field: "no_of_employees", label: "No. of Employees" },

      // Step 2
      { field: "address1", label: "Address 1" },
      { field: "city", label: "City" },
      { field: "country", label: "Country" },
      { field: "telephone", label: "Telephone" },
      { field: "email", label: "Email" },
      { field: "password", label: "Password" },
      { field: "website", label: "Website" },

      // Step 3
      { field: "commercial_registration", label: "Commercial Registration" },
      { field: "company_registration", label: "Certificate of Incorporation" },
      {
        field: "authorized_signatory_proof",
        label: "Identification Documentation of Authorised Signatories",
      },
      {
        field: "memorandum_of_association",
        label: "Memorandum of Association",
      },
      { field: "partnership_agreement", label: "Partnership Agreement" },
      {
        field: "latest_final_report_and_accounts",
        label: "Latest Financial Report and Accounts",
      },

      // Step 4
      { field: "signatory_name", label: "Signatory Name" },
      { field: "digital_signature", label: "Digital Signature" },
      { field: "declaration_date", label: "Declaration Date" },
    ];

    // VALIDATION — CHECK FIRST MISSING FIELD
    const missingField = requiredFields.find(
      (item) => !form[item.field] || form[item.field] === ""
    );

    if (missingField) {
      toast.dismiss();
      toast.error(`${missingField.label} is required`);
      return;
    }

    // Continue submitting if all fields are filled
    setLoading(true);

    try {
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        formData.append(key, form[key]);
      });

      // Add referral code
      formData.append("referral_code", "MARK-10017");

      const response = await axios.post(
        `${BaseUrl}/submitCompanyInfo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setLoading(false);
      toast.dismiss(processingToast);

      if (response.data.status === "success") {
        const token = response.data.token;
        if (token) {
          sessionStorage.setItem("authToken", token);
        }

        toast.success("Registration completed successfully!");
        navigate("/dashboard");
      }
    } catch (err) {
      setLoading(false);
      toast.dismiss(processingToast);
      console.error("Error submitting the form:", err);
      toast.error("Registration failed. Please try again.");
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(`${BaseUrl}/countries`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCountries(data);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };
    fetchCountries();
  }, [BaseUrl]);

  return (
    <section
      className="auth bg-base d-flex flex-wrap"
      style={{ width: "100%", margin: "0 auto", padding: "0 20px" }}
    >
      <div
        className="auth-right py-32 px-24 d-flex flex-column justify-content-center"
        style={{ width: "100%", maxWidth: "1200px", margin: "0 auto" }}
      >
        <div className=" mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px">
              <img src={imagePath2} alt="" />
            </Link>
            <h4 className="mb-12">Sign Up to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! please enter your detail
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            {/* Wizard Steps */}
            <div className="form-wizard">
              <div className="form-wizard-header overflow-x-auto scroll-sm pb-8 my-32">
                <ul className="list-unstyled form-wizard-list style-two">
                  <li
                    className={`form-wizard-list__item
                      ${[2, 3, 4].includes(currentStep) && "activated"}
                    ${currentStep === 1 && "active"} `}
                  >
                    <div className="form-wizard-list__line">
                      <span className="count">1</span>
                    </div>
                    <span className="text text-xs fw-semibold">
                      Company Info
                    </span>
                  </li>
                  <li
                    className={`form-wizard-list__item
                      ${[3, 4].includes(currentStep) && "activated"}
                    ${currentStep === 2 && "active"} `}
                  >
                    <div className="form-wizard-list__line">
                      <span className="count">2</span>
                    </div>
                    <span className="text text-xs fw-semibold">
                      Contact Info
                    </span>
                  </li>
                  <li
                    className={`form-wizard-list__item
                      ${[4].includes(currentStep) && "activated"}
                    ${currentStep === 3 && "active"} `}
                  >
                    <div className="form-wizard-list__line">
                      <span className="count">3</span>
                    </div>
                    <span className="text text-xs fw-semibold">
                      KYC Documents
                    </span>
                  </li>
                  <li
                    className={`form-wizard-list__item
                    ${currentStep === 4 && "active"} `}
                  >
                    <div className="form-wizard-list__line">
                      <span className="count">4</span>
                    </div>
                    <span className="text text-xs fw-semibold">
                      Declaration
                    </span>
                  </li>
                </ul>
              </div>

              <fieldset
                className={`wizard-fieldset ${currentStep === 1 && "show"}`}
              >
                <h6 className="text-md text-neutral-500">Company Info</h6>
                <div className="form-group mb-16">
                  <label
                    htmlFor="name_of_institution"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Name of Institution *
                    <Tooltip
                      title="Enter the entity’s registered legal name exactly as stated on its official incorporation or registration documents."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="name_of_institution"
                      name="name_of_institution"
                      value={form.name_of_institution}
                      onChange={handleBlacklistedNameChange}
                    />
                  </div>
                  {isBlacklistedName && (
                    <p className="text-danger mt-2">
                      Blacklisted Name Detected
                    </p>
                  )}
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="legal_status">Legal Status *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <select
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="legal_status"
                      name="legal_status"
                      value={form.legal_status}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Single Person Company (SPC)">
                        Single Person Company (SPC)
                      </option>
                      <option value="With Limited Liability (WLL)">
                        With Limited Liability (WLL)
                      </option>
                      <option value="Partnership Company">
                        Partnership Company
                      </option>
                      <option value="Limited Partnership by Shares">
                        Limited Partnership by Shares
                      </option>
                      <option value="Bahraini Shareholding Company (BSC)">
                        Bahraini Shareholding Company (BSC)
                      </option>
                      <option value="Bahraini Shareholding Company (BSC Closed)">
                        Bahraini Shareholding Company (BSC Closed)
                      </option>
                      <option value="Foreign Company Branch (Representative Office)">
                        Foreign Company Branch (Representative Office)
                      </option>
                    </select>
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="country_of_incorporation"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Country of Incorporation *
                    <Tooltip
                      title="Select the country of legal incorporation or registration."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:flag" />
                    </span>
                    <select
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="country_of_incorporation"
                      name="country_of_incorporation"
                      value={form.country_of_incorporation}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {countries.map((country) => (
                        <option key={country.NumCode} value={country.NumCode}>
                          {country.Country}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="registration_number"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Registration Number *
                    <Tooltip
                      title="Enter the entity’s official registration number as issued by the relevant registering authority (e.g., CIN, Company Number, Business Registration ID)."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="registration_number"
                      name="registration_number"
                      value={form.registration_number}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="incorporation_date"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Incorporation Date *
                    <Tooltip
                      title="Select the entity’s date of legal incorporation, as stated in its official registration documents."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:calendar" />
                    </span>
                    <input
                      type="date"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="incorporation_date"
                      name="incorporation_date"
                      value={form.incorporation_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="registering_authority"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Registering Authority
                    <Tooltip
                      title="Specify the governmental or statutory authority with which the entity is officially registered (e.g., Ministry of Corporate Affairs, Registrar of Companies, SEC, Companies House)."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="registering_authority"
                      name="registering_authority"
                      value={form.registering_authority}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="business_activity"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Business Activity *
                    <Tooltip
                      title="Provide a brief description of the entity’s primary business activities, as conducted in the ordinary course of business (e.g., Manufacturing, Trading, Investment Management, Consulting, Technology Services)."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="business_activity"
                      name="business_activity"
                      value={form.business_activity}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="annual_turnover"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Annual Turnover (US$ Millions) *
                    <Tooltip
                      title="Select the entity’s approximate annual revenue range in USD. This information is required for risk assessment and regulatory classification."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <select
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="annual_turnover"
                      name="annual_turnover"
                      value={form.annual_turnover}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">Less than 50</option>
                      <option value="2">51-99</option>
                      <option value="3">100-250</option>
                      <option value="4">251-500</option>
                      <option value="5">501-1,000</option>
                      <option value="6">Above 1,000</option>
                    </select>
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="type_of_profile"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Residential Status *
                    <Tooltip
                      title="Select “Resident” if the entity qualifies as a tax resident in Bahrain; otherwise, select “Non-resident.”"
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <select
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="type_of_profile"
                      name="type_of_profile"
                      value={form.type_of_profile}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">Resident</option>
                      <option value="2">Non-resident</option>
                    </select>
                  </div>
                </div>
                {/* <div className="form-group mb-16">
    <label htmlFor="type_of_account">Type of Account *</label>
    <div className="icon-field">
      <span className="icon top-50 translate-middle-y">
        <Icon icon="f7:briefcase" />
      </span>
      <select
        className="form-control h-56-px bg-neutral-50 radius-12"
        id="type_of_account"
        name="type_of_account"
        value={form.type_of_account}
        onChange={handleChange}
      >
        <option value="">Select</option>
        <option value="1">Individual</option>
        <option value="2">Entity</option>
      </select>
    </div>
  </div> */}
                <div className="form-group mb-16">
                  <label htmlFor="type_of_account"   style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}>
                    Type of Account *
                    <Tooltip
                      title="Indicates the account classification. For corporate clients, this is typically classified as an Entity Account."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <select
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="type_of_account"
                      name="type_of_account"
                      value={form.type_of_account} // no fallback
                      onChange={handleChange}
                    >
                      <option value="2">Entity</option>
                    </select>
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="nature_of_account"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Nature of Account *
                    {/* <Tooltip
                      title={
                        <div style={{ padding: "5px" }}>
                          <div
                            style={{ marginBottom: "8px", fontWeight: "bold" }}
                          >
                            Select the intended nature:
                          </div>
                          <ul
                            style={{
                              margin: 0,
                              paddingLeft: "15px",
                              listStyleType: "disc",
                            }}
                          >
                            <li>Investment Account</li>
                            <li>Trading Account</li>
                            <li>Asset Management</li>
                            <li>Treasury / Capital Allocation</li>
                          </ul>
                        </div>
                      }
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip> */}
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <select
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="nature_of_account"
                      name="nature_of_account"
                      value={form.nature_of_account}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">Investment in Equities</option>
                      <option value="2">Investment in Securities</option>
                      <option value="3">Investment in Bonds</option>
                      <option value="4">Investment in Commodities</option>
                      <option value="5">Investment in Mutual Funds</option>
                      <option value="6">Investment in Stocks</option>
                      <option value="7">Investment in Digital Assets</option>
                    </select>
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="anticipated_volume"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Tentative Investment (USD) *
                    <Tooltip
                      title="Select the estimated amount of funds the entity intends to invest in or maintain within the account, for compliance and risk assessment purposes."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <select
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="anticipated_volume"
                      name="anticipated_volume"
                      value={form.anticipated_volume}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">1 - 100,000 USD</option>
                      <option value="2">100,000 - 500,000 USD</option>
                      <option value="3">500,000 - 1,000,000 USD</option>
                      <option value="4">1,000,000 - 10,000,000 USD</option>
                      <option value="5">10,000,000 - 50,000,000 USD</option>
                    </select>
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="source_of_funds">Source of Funds *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <select
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="source_of_funds"
                      name="source_of_funds"
                      value={form.source_of_funds}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">Salary</option>
                      <option value="2">Business Activity</option>
                      <option value="3">Savings</option>
                      <option value="4">Pension</option>
                      <option value="5">Inheritance</option>
                      <option value="6">Gift</option>
                      <option value="7">Bonus</option>
                      <option value="8">
                        Indemnity/End of Service Payment
                      </option>
                      <option value="9">Return on Investments</option>
                      <option value="10">Other</option>
                    </select>
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="purpose_and_intended_nature_of_business"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    Purpose and Intended Nature of Business *
                    <Tooltip
                      title="Provide a clear explanation of the purpose of opening the account and the intended use of the account (e.g., long-term investments, portfolio diversification, international exposure)."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="purpose_and_intended_nature_of_business"
                      name="purpose_and_intended_nature_of_business"
                      value={form.purpose_and_intended_nature_of_business}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label
                    htmlFor="no_of_employees"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    No. of Employees *
                    <Tooltip
                      title="Select the approximate number of employees in the entity. This information is used for entity size assessment and risk profiling."
                      arrow
                      placement="top"
                    >
                      <span style={{ cursor: "pointer", display: "flex" }}>
                        <Icon
                          icon="lucide:info"
                          width="16"
                          height="16"
                          className="text-secondary-light"
                        />
                      </span>
                    </Tooltip>
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:briefcase" />
                    </span>
                    <select
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="no_of_employees"
                      name="no_of_employees"
                      value={form.no_of_employees}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="1">Less Than 10 Employees</option>
                      <option value="2">11-25 Employees</option>
                      <option value="3">26-50 Employees</option>
                      <option value="4">51-99 Employees</option>
                      <option value="5">100-500 Employees</option>
                      <option value="6">Above 500 Employees</option>
                    </select>
                  </div>
                </div>
                {/* Checkbox for conditional fields */}
                <div className="row mb-2">
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="is_regulatory_applicable"
                        checked={isRegulatoryApplicable}
                        onChange={handleRegulatoryCheckboxChange}
                      />
                      <label
                        htmlFor="is_regulatory_applicable"
                        className="form-check-label ms-2"
                      >
                        Regulatory Body or Listing Body If Applicable
                      </label>
                    </div>
                  </div>
                </div>
                {/* Conditional field */}
                {isRegulatoryApplicable && (
                  <div className="mb-3 row">
                    <label
                      className="col-md-3 col-form-label mt-1"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      Regulatory Body or Listing Body
                      <Tooltip
                        title={
                          <div style={{ padding: "4px" }}>
                            Provide details if the entity is **regulated or publicly listed**, including:
                            <ul
                              style={{
                                margin: "8px 0 0 0",
                                paddingLeft: "15px",
                                listStyleType: "disc",
                              }}
                            >
                               <li>Name of the **regulatory or supervisory authority**</li>
                              <li>Stock exchange(s), if the entity is publicly listed</li>
                            </ul>
                          </div>
                        }
                        arrow
                        placement="top"
                      >
                        <span style={{ cursor: "pointer", display: "flex" }}>
                          <Icon
                            icon="lucide:info"
                            width="16"
                            height="16"
                            className="text-secondary-light"
                          />
                        </span>
                      </Tooltip>
                    </label>
                    <div className="col-md-9">
                      <input
                        className="form-control"
                        type="text"
                        id="regulatory_body"
                        name="regulatory_body"
                        value={form.regulatory_body}
                        onChange={handleChange}
                        maxLength={100}
                        disabled={isDisable}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Enter Regulatory Body or Listing Body"
                      />
                    </div>
                  </div>
                )}

                {!form[0]?.senior_management_names ? (
                  <div className="form-check mt-2 mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="is_senior_management_applicable"
                      checked={isSeniorManagementApplicable}
                      onChange={handleSeniorManagementCheckboxChange}
                    />
                    <label
                      htmlFor="is_senior_management_applicable"
                      className="form-check-label ms-2"
                    >
                      Names of Relevant Persons in Senior Management If
                      Applicable
                    </label>
                  </div>
                ) : (
                  ""
                )}

                {isSeniorManagementApplicable && (
                  <div className="mb-2 mt-2 row">
                    <label className="col-md-3 col-form-label mt-1">
                      Names of Relevant Persons in Senior Management
                    </label>
                    <div className="col-md-9">
                      <input
                        className="form-control"
                        type="text"
                        id="senior_management_names"
                        name="senior_management_names"
                        value={form.senior_management_names}
                        onChange={handleChange}
                        maxLength={200}
                        disabled={isDisable}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Enter Names of Relevant Persons in Senior Management"
                      />
                    </div>
                  </div>
                )}

                {!form[0]?.external_auditor_name ? (
                  <div className="form-check mt-1  mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="is_external_auditor_applicable"
                      checked={isExternalAuditorApplicable}
                      onChange={handleExternalAuditorCheckboxChange}
                    />
                    <label
                      htmlFor="is_external_auditor_applicable"
                      className="form-check-label ms-2"
                    >
                      Name of External Auditor If Applicable
                    </label>
                  </div>
                ) : (
                  ""
                )}

                {isExternalAuditorApplicable && (
                  <div className="mb-3 row">
                    <label
                      className="col-md-3 col-form-label mt-1"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      Name of External Auditor
                      <Tooltip
                        title="Provide the name of the external auditing firm or auditor, if applicable, as recorded in the entity’s official financial or regulatory filings."
                        arrow
                        placement="top"
                      >
                        <span style={{ cursor: "pointer", display: "flex" }}>
                          <Icon
                            icon="lucide:info"
                            width="16"
                            height="16"
                            className="text-secondary-light"
                          />
                        </span>
                      </Tooltip>
                    </label>
                    <div className="col-md-9">
                      <input
                        className="form-control"
                        type="text"
                        id="external_auditor_name"
                        name="external_auditor_name"
                        value={form.external_auditor_name}
                        onChange={handleChange}
                        maxLength={100}
                        disabled={isDisable}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Enter the name of the external auditors"
                      />
                    </div>
                  </div>
                )}

                <div className="form-group text-end mt-32">
                  <button
                    type="button"
                    className="btn btn-primary-600 px-32"
                    onClick={nextStep}
                  >
                    Next
                  </button>
                </div>
              </fieldset>

              {/* Step 2: Contact Information */}
              <fieldset
                className={`wizard-fieldset ${currentStep === 2 && "show"}`}
              >
                <h6 className="text-md text-neutral-500">Contact Info</h6>
                <div className="form-group mb-16">
                  <label htmlFor="address1">Address 1 *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:location" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="address1"
                      name="address1"
                      value={form.address1}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="address2">Address 2 (Optional)</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:location" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="address2"
                      name="address2"
                      value={form.address2}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="city">City *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:location" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="city"
                      name="city"
                      value={form.city}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="pobox">PO Box (Optional)</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:location" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="pobox"
                      name="pobox"
                      value={form.pobox}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="country">Country *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:flag" />
                    </span>
                    <select
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="country"
                      name="country"
                      value={form.country}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      {countries.map((country) => (
                        <option key={country.NumCode} value={country.NumCode}>
                          {country.Country}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="telephone">Telephone *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:phone" />
                    </span>
                    <input
                      type="tel"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="telephone"
                      name="telephone"
                      value={form.telephone}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="fax">Fax (Optional)</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:phone" />
                    </span>
                    <input
                      type="tel"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="fax"
                      name="fax"
                      value={form.fax}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="email">Email *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:person" />
                    </span>
                    <input
                      type="email"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="email"
                      name="email"
                      value={form.email}
                      onChange={handleCombinedChange}
                    />
                  </div>
                  {!isValidEmail && (
                    <p className="text-danger mt-2">Invalid email address</p>
                  )}
                  {emailExists && (
                    <p className="text-danger mt-2">Email already exists</p>
                  )}
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="password">Password *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:lock" />
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="password"
                      name="password"
                      value={form.password}
                      onChange={(e) => {
                        handleChange(e);
                        calculatePasswordStrength(e.target.value);
                      }}
                    />
                    <span
                      className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                      onClick={togglePasswordVisibility}
                    />
                  </div>
                  {form.password.length > 0 && (
                    <div className="mt-2">
                      <p className="text-sm">
                        Password Strength:{" "}
                        <span
                          className={`${
                            strength === 0
                              ? "text-danger"
                              : strength === 1
                              ? "text-warning"
                              : strength === 2
                              ? "text-info"
                              : "text-success"
                          }`}
                        >
                          {strength === 0
                            ? "Too Weak"
                            : strength === 1
                            ? "Weak"
                            : strength === 2
                            ? "Good"
                            : "Strong"}
                        </span>
                      </p>
                    </div>
                  )}
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="website">Website *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:globe" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="website"
                      name="website"
                      value={form.website}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group text-end mt-32">
                  <button
                    type="button"
                    className="btn btn-secondary-600 px-32 me-3"
                    onClick={prevStep}
                  >
                    Previous
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary-600 px-32"
                    onClick={nextStep}
                  >
                    Next
                  </button>
                </div>
              </fieldset>

              {/* Step 3: KYC Documents */}
              <fieldset
                className={`wizard-fieldset ${currentStep === 3 && "show"}`}
              >
                <h6 className="text-md text-neutral-500">KYC Documents</h6>
                <div className="form-group mb-16">
                  <label htmlFor="commercial_registration">
                    Commercial Registration *
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="file"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="commercial_registration"
                      name="commercial_registration"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="vat_registration">
                    VAT Registration Certificate{" "}
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="file"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="vat_registration"
                      name="vat_registration"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="company_registration">
                    Certificate of Incorporation or Certificate of Commercial
                    Registration *
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="file"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="company_registration"
                      name="company_registration"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="authorized_signatory_proof">
                    Identification Documentation of the Authorised Signatories
                    of the Account *
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="file"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="authorized_signatory_proof"
                      name="authorized_signatory_proof"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="memorandum_of_association">
                    Memorandum of Association *
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="file"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="memorandum_of_association"
                      name="memorandum_of_association"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="articles_of_association">
                    Articles of Association{" "}
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="file"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="articles_of_association"
                      name="articles_of_association"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="partnership_agreement">
                    Partnership Agreement *
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="file"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="partnership_agreement"
                      name="partnership_agreement"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="board_resolution">Board Resolution </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="file"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="board_resolution"
                      name="board_resolution"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="list_of_authorized_signatories">
                    List of Authorized Signatories{" "}
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="file"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="list_of_authorized_signatories"
                      name="list_of_authorized_signatories"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="latest_final_report_and_accounts">
                    Latest Financial Report and Accounts *
                  </label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:doc" />
                    </span>
                    <input
                      type="file"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="latest_final_report_and_accounts"
                      name="latest_final_report_and_accounts"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>

                <div className="form-group text-end mt-32">
                  <button
                    type="button"
                    className="btn btn-secondary-600 px-32 me-3"
                    onClick={prevStep}
                  >
                    Previous
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary-600 px-32"
                    onClick={nextStep}
                  >
                    Next
                  </button>
                </div>
              </fieldset>

              {/* Step 4: Declaration */}
              <fieldset
                className={`wizard-fieldset ${currentStep === 4 && "show"}`}
              >
                <h6 className="text-md text-neutral-500">Declaration</h6>
                <div className="form-group mb-16">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="acting_on_my_behalf"
                      name="acting_on_my_behalf"
                      checked={form.acting_on_my_behalf}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="acting_on_my_behalf"
                    >
                      I/We hereby confirm that I/we are acting and would, in
                      future will also be acting on my/our behalf for the
                      purpose of transactions, new accounts or providing any
                      further information required by Blue Aster Capital BSC ©.
                    </label>
                  </div>
                </div>
                <div className="form-check d-flex align-items-center ">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="acting_on_behalf_of"
                    name="acting_on_behalf_of"
                    onChange={handleChange}
                    checked={form.acting_on_behalf_of}
                  />
                  <label
                    className="form-check-label ms-2"
                    htmlFor="declaration2"
                  >
                    I/We hereby confirm that I/we are acting on behalf of
                  </label>
                  <input
                    type="text"
                    className="form-control ms-2"
                    id="acting_on_behalf_name"
                    name="acting_on_behalf_name"
                    placeholder="Enter name"
                    onChange={handleChange}
                    style={{ maxWidth: "300px" }}
                  />
                </div>
                <div className="form-group mb-16">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="information_true"
                      name="information_true"
                      checked={form.information_true}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="information_true"
                    >
                      I/We hereby confirm the information provided above is
                      true, accurate and complete. Subject to applicable local
                      laws, I/we hereby consent for Blue Aster Capital BSC © or
                      any of its affiliates to share our information with
                      domestic or overseas regulators or tax authorities where
                      necessary.
                    </label>
                  </div>
                </div>
                <div className="form-group mb-16">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="notify_on_change"
                      name="notify_on_change"
                      checked={form.notify_on_change}
                      onChange={handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="notify_on_change"
                    >
                      I/We agree and undertake to notify Blue Aster Capital BSC
                      © within 30 calendar days if there is a change in any
                      information which I/we have provided.
                    </label>
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="signatory_name">Signatory Name *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:person" />
                    </span>
                    <input
                      type="text"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="signatory_name"
                      name="signatory_name"
                      value={form.signatory_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="digital_signature">Digital Signature *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:pencil" />
                    </span>
                    <div
                      className="border rounded shadow-sm p-2 bg-light"
                      style={{
                        display: "inline-block",
                        width: "300px",
                        height: "200px",
                      }}
                    >
                      <SignatureCanvas
                        ref={sigPad}
                        penColor="black"
                        canvasProps={{
                          width: 280,
                          height: 180,
                          className: "sigCanvas w-100 h-100",
                        }}
                        backgroundColor="#fff"
                      />
                    </div>{" "}
                    <br></br>
                    <div className="btn-group mt-3">
                      <button
                        type="button"
                        className="btn btn-warning"
                        onClick={clear}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={trim}
                      >
                        Save Signature
                      </button>
                    </div>
                    {trimmedDataURL && (
                      <div className="mt-3">
                        <img src={trimmedDataURL} alt="Your Signature" />
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-group mb-16">
                  <label htmlFor="declaration_date">Declaration Date *</label>
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="f7:calendar" />
                    </span>
                    <input
                      type="date"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="declaration_date"
                      name="declaration_date"
                      value={form.declaration_date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group text-end">
                  <button
                    onClick={prevStep}
                    type="button"
                    className="form-wizard-prev-btn btn btn-secondary-600 px-32"
                  >
                    Previous
                  </button>
                  <button
                    disabled={isBlacklistedName || emailExists}
                    type="submit"
                    className="form-wizard-next-btn btn btn-primary-600 px-32"
                  >
                    Submit
                  </button>
                </div>
              </fieldset>
            </div>
          </form>
        </div>
        <div className="mt-32 text-center text-sm">
          <p className="mb-0">
            Already have an account?{" "}
            <Link to="/sign-in" className="text-primary-600 fw-semibold">
              Sign In
            </Link>
          </p>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </section>
  );
};

export default SignUpLayer;
